import { SafeUrl } from "@angular/platform-browser";
import moment from 'moment';

import { MarvDateService } from '@marv/services';
import { StoreDashOperationActivityReport, OperationCard, Operation } from '@app/models';

export class OperationItem {
    id: number;   
    name: string;
    logo: string|SafeUrl;
    type: string;
    startDateIntervention: number; 
    endDateIntervention: number; 
    startDatePlanning: number; 
    endDatePlanning: number; 
    plannedActivitiesCount: number; 
    hiddenByDefault: boolean;
    quotaTotal: number = 0;
    quotaRealized: number = 0;
    quotaPlanned: number = 0;
    quotaRemaining: number = 0;
    
    daysBeforePlanningOpening: number|null = null;
    isPlanningOpened: boolean = false;    
    daysBeforePlanningClosing: number|null = null;
    isPlanningClosed: boolean = false;
    
    static FromStoreDashOperation (storeDashOperation: StoreDashOperationActivityReport): OperationItem{
        let operationItem = new OperationItem();
        operationItem.id = storeDashOperation.operation.id;       
        operationItem.name = storeDashOperation.operation.name;        
        operationItem.type = storeDashOperation.typeOfMissionCode;
        operationItem.startDateIntervention = storeDashOperation.startDayIntervention;
        operationItem.endDateIntervention = storeDashOperation.endDayIntervention;
        operationItem.startDatePlanning = storeDashOperation.startDayPlanning;
        operationItem.endDatePlanning = storeDashOperation.endDayPlanning;
        operationItem.plannedActivitiesCount = storeDashOperation.plannedActivitiesCount;      
        operationItem.hiddenByDefault = storeDashOperation.hiddenByDefault;      
        
        if (operationItem.startDatePlanning !== null && operationItem.startDatePlanning > 0) {
            let today = MarvDateService.GetToday();
            operationItem.daysBeforePlanningOpening = Math.ceil(operationItem.startDatePlanning - today);
            operationItem.isPlanningOpened = operationItem.daysBeforePlanningOpening <= 0;            
        }
        
        if (operationItem.endDatePlanning !== null && operationItem.endDatePlanning > 0) {
            let today = MarvDateService.GetToday();
            operationItem.daysBeforePlanningClosing = Math.ceil(operationItem.endDatePlanning - today);
            operationItem.isPlanningClosed = operationItem.daysBeforePlanningClosing < 0;
            
        }
          
        return operationItem;
    }
    
    static FromOperationCard (operationCard: OperationCard): OperationItem{
        let operationItem = new OperationItem();
        operationItem.id = operationCard.id;       
        operationItem.name = operationCard.name;        
        operationItem.logo = operationCard.operationLogoUrl;        
        operationItem.type = operationCard.typeOfMissionCode;
        operationItem.startDateIntervention = operationCard.earliestPlannableDate;           
        operationItem.endDateIntervention = operationCard.latestPlannableDate;           
        operationItem.startDatePlanning = operationCard.planningOpenFrom;           
        operationItem.endDatePlanning = operationCard.planningOpenUntil;           
        operationItem.plannedActivitiesCount = 0;      
        operationItem.hiddenByDefault = !operationCard.currentlyActive;   
        operationItem.daysBeforePlanningClosing = operationCard.uiDaysBeforePlanningClosing;
        operationItem.isPlanningClosed = operationCard.uiIsPlanningClosed;   
        
        if(operationCard.hourQuotaDefined){
            if(operationCard.hourlyQuota){
                operationItem.quotaTotal = operationCard.hourlyQuota?.quotaAllowance;
                operationItem.quotaRealized = operationCard.hourlyQuota?.consumedAndRealisedQuota;
                operationItem.quotaPlanned = operationCard.hourlyQuota?.quotaAllowance - (operationCard.hourlyQuota?.consumedAndRealisedQuota+operationCard.hourlyQuota?.availableQuota);
                operationItem.quotaRemaining = operationCard.hourlyQuota?.availableQuota;
            }
        }
        else{
            operationItem.quotaTotal = operationCard.quotaTotal;
            operationItem.quotaRealized = operationCard.quotaRealized;
            operationItem.quotaPlanned = operationCard.quotaTotal - (operationCard.quotaRealized+operationCard.quotaRemaining);
            operationItem.quotaRemaining = operationCard.quotaRemaining;
        }
             
        if (operationItem.startDatePlanning !== null && operationItem.startDatePlanning > 0) {
            let today = MarvDateService.GetToday();
            operationItem.daysBeforePlanningOpening = Math.ceil(operationItem.startDatePlanning - today);
            operationItem.isPlanningOpened = operationItem.daysBeforePlanningOpening <= 0;
            
        }
                       
        return operationItem;
    }
    
    static FromOperation (operation: Operation): OperationItem{
        let operationItem = new OperationItem();
        operationItem.id = operation.id;       
        operationItem.name = operation.name;        
        operationItem.type = operation.typeOfMission?.code;
        let start = MarvDateService.FromDate(operation.start);
        if(start){
            operationItem.startDateIntervention = start;                     
        }         
        let end = MarvDateService.FromDate(operation.end);
        if(end){
            operationItem.endDateIntervention = end;      
        } 
        operationItem.startDatePlanning = operation.startDayPlanning;     
        operationItem.endDatePlanning = operation.endDayPlanning;   
        operationItem.plannedActivitiesCount = 0;      
        operationItem.hiddenByDefault = false;   
        operationItem.daysBeforePlanningClosing = operation.uiDaysBeforePlanningClosing;
        operationItem.isPlanningClosed = operation.uiIsPlanningClosed;
        
        operationItem.quotaTotal = operation.quotaTotal;
        operationItem.quotaRealized = operation.quotaRealized;
        operationItem.quotaPlanned = operation.quotaTotal - (operation.quotaRealized+operation.quotaRemaining);
        operationItem.quotaRemaining = operation.quotaRemaining;
                       
        if (operationItem.startDatePlanning !== null && operationItem.startDatePlanning > 0) {
            let today = MarvDateService.GetToday();
            operationItem.daysBeforePlanningOpening = Math.ceil(operationItem.startDatePlanning - today);
            operationItem.isPlanningOpened = operationItem.daysBeforePlanningOpening <= 0;
            
        }
                       
        return operationItem;
    }
}

